import React from 'react';
import { Grid, Message } from 'semantic-ui-react';

class NoAccess extends React.Component {
  render() {
    return (
      <Grid verticalAlign='middle' centered columns='2' style={{height : '100%'}}>
        <Grid.Row>
          <Grid.Column>
            <Message
              warning
              icon='lock'
              header="You don't have permission to access this account."
              content={'Contact your organization owner if you believe this is an error.'}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default NoAccess;
